
import { createStore } from '@/api/store'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import CardContainer from '@/components/CardContainer/index.vue'
import LimitField from '@/components/LimitField/index.vue'
import { imagePreview } from '@/utils/util'
import { chooseFile } from '@/utils/h5ToApp'
import SelectIconTypePop from './selectIconTypePop.vue'
import timePopup from './timePopup.vue'
import scroll from '@/mixins/scroll'
import { Debounce } from '@/core/decorator';
import { phone } from '@/core/regexp'
import { toBaiDuMap, LoginReturnDataDto } from '@/utils/h5ToApp'
import { chooseUserType } from '@/api/creatCompany'
import { Getter, Action } from 'vuex-class'

@Component({
  name: 'CreateStore',
  components: {
    CardContainer,
    SelectIconTypePop,
    timePopup,
    LimitField
  }
})
export default class CreateStore extends Mixins(scroll) {

    @Getter info!: LoginReturnDataDto
    @Getter userId!: string
    @Getter mobile!: string
    @Getter multiStoreList!: (string | number)[]
    @Action setCompanyId!: (companyId: string) => void
    @Action setCompanyName!: (companyName: string) => void
    @Action setUserId!: (userId: string) => void

    form = {
        storeName: '',
        companyName: '',
        address: '',
        receiveAddressDtl: '',
        longitude: 0,
        latitude: 0,
        jrAddress: '',
        storeHeadPortrait: '',
        openOnlineStore: 0,
        pickupStartTime: '',
        pickupEndTime: '',
        takeStartTime: '',
        takeEndTime: '',
        receiveMobile: '',
    }
    phonePattern = phone
    mobileErrorMsg = ''
    isDisabled = true
    timePopupType = 1
    isPickup = false
    storeNameWarning = ''
    isShake = false


    created() {
      // 恢复缓存的表单数据
      const cachedForm = sessionStorage.getItem('createStoreFormCache')
      if (cachedForm) {
          try {
              const parsedForm = JSON.parse(cachedForm)
              this.form = { ...this.form, ...parsedForm }
          } catch (e) {
              console.error('恢复表单数据失败', e)
          }
      }
      // 恢复缓存的地址信息
      const cachedAddressInfo = sessionStorage.getItem('editStoreAddressInfo')
      if (cachedAddressInfo) {
        try {
          const parsedAddressInfo = JSON.parse(cachedAddressInfo)
          this.form = { ...this.form, ...parsedAddressInfo }
        } catch (e) {
          console.error('恢复地址信息失败', e)
        }
      }

      // 初始化时检查表单是否完整
      this.checkFormComplete()
    }

    toAddressManage() {
      // 跳转到原生地图前,收起键盘,防止返回时底部被撑高
      // setTimeout(() => {
      //   toBaiDuMap().then((res: any) => {
      //     this.$set(this.form, 'address', res.address)
      //     this.$set(this.form, 'jrAddress', res.address)
      //     this.$set(this.form, 'receiveAddressDtl', res.addressDtl)
      //     this.$set(this.form, 'longitude', res.longitude)
      //     this.$set(this.form, 'latitude', res.latitude)
      //   })
      // }, 100)
      this.$router.push({
        path: '/addressMap',
        query: {
          longitude: String(this.form.longitude),
          latitude: String(this.form.latitude),
        }
      })
    }

    // 监听表单所有字段变化
    @Watch('form', { deep: true })
    onFormChange() {
      this.checkFormComplete()
      // 实时保存表单数据
      sessionStorage.setItem('createStoreFormCache', JSON.stringify(this.form))
    }

    // 监听店铺名称变化，检查长度并在输入框外部显示提示（中文算2字符）
    @Watch('form.storeName')
    onStoreNameChange(val: string) {
      if (!val) {
        this.storeNameWarning = ''
        return
      }
      const length = Array.from(val).reduce((count, char) => {
        return count + (char.charCodeAt(0) > 127 ? 2 : 1)
      }, 0)
      // 超过 30 字符（即 15 个汉字）时显示提示
      if (length > 30) {
        this.storeNameWarning = '15个汉字（30字符）内'
      } else {
        this.storeNameWarning = ''
      }
    }

    // 右侧显示的字符计数（用于展示 current/15），这里按字符长度计算（简单计数）
    get storeNameCount() {
      return this.form.storeName ? this.form.storeName.length : 0
    }

    // 检查表单是否填写完整
    checkFormComplete() {
      const { storeName, companyName, address, receiveAddressDtl, storeHeadPortrait, openOnlineStore, pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } = this.form
      // 基础必填项
      const baseRequired = storeName && companyName && address && receiveAddressDtl && storeHeadPortrait
      // 如果开通在线店铺，时间字段也是必填
      const timeRequired = openOnlineStore == 1 
        ? !!(pickupStartTime && pickupEndTime && takeStartTime && takeEndTime)
        : true
      // 所有必填项都有值时，启用按钮
      this.isDisabled = !(baseRequired && timeRequired)
    }

    // 时间
    // type(1营业 2提货)
    onShowTimePopup(type) {
      let params
      params = {
        pickupStartTime: this.form.pickupStartTime,
        pickupEndTime: this.form.pickupEndTime,
        takeStartTime: this.form.takeStartTime,
        takeEndTime: this.form.takeEndTime,
        pickerType: type
      }
      ;(this.$refs.timePopupRef as any).showPop(params)
    }

    onTimePopupConfirm({ pickupStartTime, pickupEndTime, takeStartTime, takeEndTime }) {
      this.form.pickupStartTime = pickupStartTime
      this.form.pickupEndTime = pickupEndTime
      this.form.takeStartTime = takeStartTime
      this.form.takeEndTime = takeEndTime
    }

    // 营业时间（回显）
    get pickupTime() {
      const { pickupStartTime, pickupEndTime } = this.form
      return pickupStartTime && pickupEndTime
        ? `${pickupStartTime}-${pickupEndTime}`
        : ''
    }

    // 提货时间（回显）
    get takeTime() {
      const { takeStartTime, takeEndTime } = this.form
      return takeStartTime && takeEndTime
        ? `${takeStartTime}-${takeEndTime}`
        : ''
    }

    // 计算加权长度（汉字算2字符）
    getWeightedLength(val: string) {
      if (!val) return 0
      return Array.from(val).reduce((count, char) => {
        return count + (/[\u4e00-\u9fa5]/.test(char) ? 2 : 1)
      }, 0)
    }

    validateMobile() {
      // 未开启微店不校验
      if (!this.form.openOnlineStore) {
        this.mobileErrorMsg = ''
        return true
      }
      
      const value = this.form.receiveMobile
      if (!value) {
        this.mobileErrorMsg = '请输入11位手机号'
        this.isShake = true
        return false
      }
      if (!this.phonePattern.test(value)) {
        this.mobileErrorMsg = '请输入正确格式的手机号码'
        this.isShake = true
        return false
      }
      this.mobileErrorMsg = ''
      this.isShake = false
      return true
    }

    imagePreview = imagePreview


    showIconTypePop() {
      ;(this.$refs.selectIconTypePop as any).showPop()
    }

    // 获取图片 URL
    getImageUrl(path: string) {
      // 直接使用 $downloadUrl 处理文件路径
      return this.$downloadUrl(path)
    }

    @Debounce(500)
    async submit() {
      this.$toast({
        message: '创建中...',
        duration: 10000,
        forbidClick: true,
      })
      let hasError = false
      // 校验店铺名称长度
      if (this.getWeightedLength(this.form.storeName) > 30) {
          (this.$refs.storeNameRef as any).shake()
          hasError = true
      }
      // 校验公司名称长度
      if (this.getWeightedLength(this.form.companyName) > 100) {
          (this.$refs.companyNameRef as any).shake()
          hasError = true
      }
      // 校验详细地址长度
      if (this.getWeightedLength(this.form.receiveAddressDtl) > 100) {
          (this.$refs.addressDtlRef as any).shake()
          hasError = true
      }

      // 校验手机号
      if (!this.validateMobile()) {
        hasError = true
      }

      if (hasError) {
        this.$toast.clear()
        return
      }

      try {
        await (this.$refs.form as any).validate()
      } catch (e) {
        this.$toast.clear()
        return
      }
      if (!this.form.storeHeadPortrait) {
        this.$toast('请上传店铺图标')
        this.$toast.clear()
        return
      }
      const params = this.form.openOnlineStore ? {
        ...this.form,
        pickupStartTime: `${this.form.pickupStartTime}:00`,
        pickupEndTime: `${this.form.pickupEndTime}:00`,
        takeStartTime: `${this.form.takeStartTime}:00`,
        takeEndTime: `${this.form.takeEndTime}:00`,
        openOnlineStore: 1,
      } : {
        ...this.form,
        pickupStartTime: '',
        pickupEndTime: '',
        takeStartTime: '',
        takeEndTime: '',
        openOnlineStore: 0,
      }
      try {
        const storeRes = await createStore(params)
        if (storeRes.code === '000000') {
          const param = {
            oldUserId: this.info.userId, // 登录账号userId
            userId: storeRes.data.userId // 新创建的公司对应的userId
          }
          const chooseUserTypeRes = await chooseUserType(param, false)
          this.setCompanyId(storeRes.data.companyId)
          this.setCompanyName(params.companyName)
          this.setUserId(storeRes.data.userId)

          const logoUrl = window.location.origin + this.$downloadUrl(params.storeHeadPortrait) // 完整的url地址

          // 传给原生信息
          const obj = {
            companyInfo: {...storeRes.data, ...params},
            userInfo: chooseUserTypeRes.data,
            logoUrl,
            res: JSON.stringify(chooseUserTypeRes)
          }

          // 处理多店数据
          this.$store.commit('SET_IS_MULTI_STORE', false)
          this.$store.commit('SET_MULTI_STORE_LIST', [])

          // 缓存信息
          this.$store.dispatch('GetInfo', { ...params, ...storeRes.data, logoUrl, ...chooseUserTypeRes.data })
          // 进入工作台
          this.$router.replace('/workbench')
          this.$toast.clear()
        } else {
          this.$toast.fail(storeRes.msg)
          this.$toast.clear()
        }
      } catch (e) {
        this.$toast.fail(e.data.msg || '创建店铺失败')
        this.$toast.clear()
      }
    }
}
